import React, { useRef, useEffect } from "react";
import "./../styles/components/TeamSection.css";
import {
  FaUserTie,
  FaTools,
  FaHammer,
  FaPenFancy,
  FaRulerCombined,
  FaUsers,
} from "react-icons/fa";

const teamMembers = [
  {
    icon: <FaUserTie size={28} color="#ffdd59" />,
    role: "Master Builder",
    description:
      "Plans and executes every project with strength, stability, and care.",
  },
  {
    icon: <FaTools size={28} color="#ffdd59" />,
    role: "Hands That Build",
    description:
      "Manages resources and processes, ensuring smooth and timely delivery.",
  },
  {
    icon: <FaHammer size={28} color="#ffdd59" />,
    role: "Structural Expert",
    description:
      "Provides technical expertise, ensuring safety, scalability, and durability.",
  },
  {
    icon: <FaPenFancy size={28} color="#ffdd59" />,
    role: "Creative Architect",
    description:
      "Designs innovative yet practical spaces with balance and precision.",
  },
  {
    icon: <FaRulerCombined size={28} color="#ffdd59" />,
    role: "Artistic Interior Decorator",
    description:
      "Transforms interiors with comfort, style, and modern functionality.",
  },
  {
    icon: <FaUsers size={28} color="#ffdd59" />,
    role: "Skilled Workforce",
    description:
      "Delivers quality workmanship, fine details, and reliable finishes.",
  },
];

const TeamSection = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const cards = containerRef.current.querySelectorAll(".team-card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("visible");
            }, index * 200); // staggered fade-up
            observer.unobserve(entry.target); // animate only once
          }
        });
      },
      { threshold: 0.3 }
    );

    cards.forEach((card) => observer.observe(card));
  }, []);

  return (
    <section id="team" className="team-section" ref={containerRef}>
      <div className="team-container">
        <h2 className="team-title">People Behind Our Work</h2>
        <p className="team-description">
          Every strong project needs a strong team. At Jai Vishwakarma
          Enterprises, our people are the foundation of success—skilled,
          experienced, and committed to turning every vision into reality.
        </p>

        <div className="team-features">
          {teamMembers.map((member, index) => (
            <div
              className="team-card"
              key={index}
              style={{ transitionDelay: `${index * 0.1}s` }}
            >
              <div className="team-icon">{member.icon}</div>
              <div className="team-text">
                <h4>{member.role}</h4>
                <p>{member.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
